const moneyFormatter = new Intl.NumberFormat('ru-RU', {
  style: 'currency',
  currency: 'RUB',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const statusLabels = {
  created: 'Создан',
  request_sent: 'Отправлен в кассу',
  sending: 'Отправляется',
  pending: 'В обработке',
};

const typeLabels = { sale: 'Приход', refund: 'Возврат', correction: 'Коррекция' };

function formatDateTime(value) {
  if (!value) return '—';
  const match = value.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/);
  return match ? `${match[3]}.${match[2]}.${match[1]} ${match[4]}:${match[5]}` : value;
}

export function ProfilePendingReceiptsWidget({ result, loading, error }) {
  const receipts = result?.pendingReceipts ?? [];

  return (
    <section className="profile-pending-receipts" aria-labelledby="profile-pending-title">
      <div className="profile-pending-receipts__header">
        <h3 id="profile-pending-title">Не подтверждено кассой</h3>
        <p className="muted">Чеки PayKeeper за выбранный период</p>
      </div>

      {result ? (
        <>
          <div className="profile-pending-receipts__summary">
            <strong>{moneyFormatter.format(result.pendingAmount)}</strong>
            <span>{result.pendingReceiptsCount} чек.</span>
          </div>
          {receipts.length ? (
            <div className="profile-pending-receipts__list" role="list" aria-label="Чеки без подтверждения кассы" tabIndex={0}>
              {receipts.map((receipt, index) => (
                <article className="profile-pending-receipts__item" role="listitem" key={`${receipt.id}-${index}`}>
                  <div className="profile-pending-receipts__item-head">
                    <strong>{receipt.clientName || 'Клиент не указан'}</strong>
                    <b>{moneyFormatter.format(receipt.amount)}</b>
                  </div>
                  <div className="profile-pending-receipts__item-meta">
                    <span>Запрос чека: {formatDateTime(receipt.requestedAt)}</span>
                    <span>{typeLabels[receipt.type] ?? receipt.type}</span>
                    <span>{statusLabels[receipt.status] ?? receipt.status}</span>
                  </div>
                  <dl className="profile-pending-receipts__details">
                    <div><dt>Почта</dt><dd>{receipt.email || '—'}</dd></div>
                    <div><dt>Телефон</dt><dd>{receipt.phone || '—'}</dd></div>
                    <div><dt>ID платежа</dt><dd>{receipt.paymentId || '—'}</dd></div>
                    <div><dt>ID чека</dt><dd>{receipt.id || '—'}</dd></div>
                    {receipt.orderId && <div><dt>ID заказа</dt><dd>{receipt.orderId}</dd></div>}
                  </dl>
                </article>
              ))}
            </div>
          ) : (
            <p className="profile-pending-receipts__empty">За выбранный период чеков без подтверждения кассы нет.</p>
          )}
        </>
      ) : (
        <p className="profile-pending-receipts__empty">
          {loading
            ? 'Получаем чеки PayKeeper…'
            : error
              ? 'Не удалось получить список. Повторите расчёт в «Обороте».'
              : 'Выберите период и рассчитайте оборот, чтобы увидеть чеки.'}
        </p>
      )}
    </section>
  );
}
